export default __webpack_public_path__ + "static/media/Hood of the Silent Slayer.827a9889.jpg";